import React from 'react'

export default function Header() {
  return (
    <h1 className='header text-center fa-3x mx-0 py-5'>Books 23</h1>
  )
}
